import { isInFuturesApp } from '../../base/env/app/isInFuturesApp';
import { isGPhone } from '../../base/env/platform/isGPhone';
import { isInThsApp } from '../../base/env/app/isInThsApp';
import { isInIFindApp } from '../../base/env/app/isInIFindApp';
import { isInAInvestApp } from '../../base/env/app/isInAInvestApp';

type HideCallback = () => void;

// 存储所有回调函数
const callbacks: HideCallback[] = [];

// 统一的回调处理函数
const handleHide = () => {
  callbacks.forEach((callback) => {
    try {
      callback();
    } catch (error) {
      console.warn('执行onHide回调出错:', error);
    }
  });
};

// 是否已经注册过监听器
let isListenerRegistered = false;

// 存储事件监听器引用
let visibilityChangeHandler: (() => void) | null = null;

function isNativeApp(): boolean {
  return isInThsApp() || (isInFuturesApp() && isGPhone()) || isInIFindApp() || isInAInvestApp();
}

/**
 * 监听页面隐藏
 *
 * 该函数用于注册页面隐藏时的回调函数。在不同环境下有不同的实现：
 * - 在客户端环境（同花顺App或期货通Android端）下，使用 registerWebListener 注册回调
 * - 在其他环境下，使用 visibilitychange 事件监听页面隐藏
 *
 * 特点：
 * 1. 支持注册多个回调函数
 * 2. 避免重复注册相同的回调
 * 3. 只注册一次事件监听器
 * 4. 包含错误处理机制
 *
 * @param callback - 页面隐藏时的回调函数
 *
 * @example
 * ```ts
 * // 注册单个回调
 * onHide(() => {
 *   console.log('页面隐藏了');
 * });
 *
 * // 注册多个回调
 * onHide(() => {
 *   pauseVideo();
 * });
 * onHide(() => {
 *   saveData();
 * });
 * ```
 */
export function onHide(callback: HideCallback): void {
  // 防止重复添加相同的回调
  if (callbacks.includes(callback)) {
    return;
  }

  callbacks.push(callback);

  if (!isListenerRegistered) {
    if (isNativeApp()) {
      window.registerWebListener?.('onHide', handleHide);
    } else {
      // 其他环境
      visibilityChangeHandler = () => {
        if (document.hidden) {
          handleHide();
        }
      };
      document.addEventListener('visibilitychange', visibilityChangeHandler);
    }
    isListenerRegistered = true;
  }
}